// extracted by mini-css-extract-plugin
module.exports = {"relativeTimestamp":"relative-timestamp_relativeTimestamp__ZKinR","urgent":"relative-timestamp_urgent__MAqGQ"};